import axios from "axios";
const { server } = require("../../server");

export const loadUser = () => async (dispatch) => {
  try {
    dispatch({ type: "LoadUserRequest" });
    const { data } = await axios.get(`${server}/user/get-user`, {
      withCredentials: true,
    });
    dispatch({
      type: "LoadUserSuccess",
      payload: data?.user,
    });
  } catch (error) {
    dispatch({
      type: "LoadUserFail",
      payload: error.response?.data?.message || "Unable to load user",
    });
  }
};

export const loadSeller = () => async (dispatch) => {
  try {
    dispatch({ type: "LoadSellerRequest" });
    const token = localStorage.getItem("shop_token");
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const { data } = await axios.get(`${server}/shop/get-seller`, {
      withCredentials: true,
      headers,
    });
    dispatch({
      type: "LoadSellerSuccess",
      payload: data?.seller,
    });
  } catch (error) {
    dispatch({
      type: "LoadSellerFail",
      payload: error.response?.data?.message || "Unable to load seller",
    });
  }
};

// user update information
export const updateUserInformation =
  (name, email, password, phoneNumber) => async (dispatch, action) => {
    try {
      dispatch({ type: "updateUserInfoRequest" });
      const { data } = await axios.put(
        `${server}/user/update-user-info`,
        {
          name,
          email,
          password,
          phoneNumber,
        },
        {
          withCredentials: true,
        },
      );
      dispatch({
        type: "updateUserInfoSuccess",
        payload: data.user,
      });
    } catch (error) {
      dispatch({
        type: "updateUserInfoFail",
        payload: error.response?.data?.message || "Unable to update user",
      });
    }
  };

// update user address
export const updateUserAddress =
  (country, city, address1, address2, zipCode, addressType) =>
  async (dispatch) => {
    try {
      dispatch({ type: "updateUserAddressRequest" });
      const { data } = await axios.put(
        `${server}/user//update-user-addresses`,
        { country, city, address1, address2, zipCode, addressType },
        {
          withCredentials: true,
        },
      );
      dispatch({
        type: "updateUserAddressSuccess",
        payload: {
          successMessage: "User address updated successfully",
          user: data.user,
        },
      });
    } catch (error) {
      dispatch({
        type: "updateUserAddressFail",
        payload: error.response?.data?.message || "Unable to update user",
      });
    }
  };

// delete user address
export const deleteUserAddress = (id) => async (dispatch) => {
  try {
    dispatch({ type: "deleteUserAddressRequest" });
    const { data } = await axios.delete(
      `${server}/user/delete-user-address/${id}`,
      {
        withCredentials: true,
      },
    );
    dispatch({
      type: "deleteUserAddressSuccess",
      payload: {
        successMessage: "Address deleted successfully!",
        user: data?.user,
      },
    });
  } catch (error) {
    dispatch({
      type: "deleteUserAddressFail",
      payload: error.response?.data?.message || "Unable to delete user",
    });
  }
};

// get all users -- admin
export const getAllUsers = () => async (dispatch) => {
  try {
    dispatch({ type: "getAllUsersRequest" });
    const { data } = await axios.get(`${server}/user/admin-all-users`, {
      withCredentials: true,
    });
    dispatch({ type: "getAllUsersSuccess", payload: data?.users });
  } catch (error) {
    dispatch({
      type: "getAllUsersFail",
      payload: error.response?.data?.message || "Unable to delete user",
    });
  }
};

// Logout user
export const logoutUser = () => async (dispatch) => {
  try {
    dispatch({ type: "logoutRequest" });

    const { data } = await axios.get(`${server}/user/logout`, {
      withCredentials: true,
    });

    // Clear localStorage
    localStorage.removeItem("user");

    dispatch({
      type: "logoutSuccess",
      payload: data?.message,
    });
  } catch (error) {
    dispatch({
      type: "logoutFail",
      payload: error.response?.data?.message || "Logout failed",
    });
  }
};
